<template>
  <div>
    <Loading v-show="loading" />
  </div>
</template>

<script>
import Loading from '@/ui/shared/Loading.vue'
import { authService } from '@/modules/auth/services/auth.service'
import { buildMenuItens } from '@/modules/auth/utils/menu-loader'
import { desembaralhar } from '@/modules/auth/utils/scramble'
import { mapMutations } from 'vuex'

export default {
  name: 'LoginRedirectView',
  components: { Loading },
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    this.sigin()
  },
  methods: {
    ...mapMutations('user', ['addUserLogged', 'addItemMenu', 'removeItemMenu']),
    async sigin() {
      try {
        const response = await authService.login({
          userName: desembaralhar(this.$route.params.username),
          password: desembaralhar(this.$route.params.password),
        })
        const content = response.data.content
        await this.$store.dispatch('auth/setAuthData', content)
        this.addUserLogged(content)
        this.loadMenu(content)
        this.$router.replace(this.$route.query.redirect || '/dashboard')
      } catch (e) {
        // erros já são exibidos pelo Messages; para o loading para não travar a tela
        this.loading = false
      }
    },
    loadMenu(content) {
      this.removeItemMenu()
      this.addItemMenu(buildMenuItens(content.user.rules))
    },
  },
}
</script>
